<template>
  <div name="item-desc" class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choiceDisp}" @click="toggleChoiceDisp()">
    <div class="main-label" :class="{ 'active color-skin' : choiceDisp}"><label>{{choice.grad}} : {{choice.namgrad}} ({{parseFloat(choice.score).toFixed(2)}} {{ labelsHrms15e['C40'] }})</label></div>
    <div class="more-label" v-show="choiceDisp">{{ choice.desnote }}</div>
  </div>
</template>

<script>
export default {
  name: 'item-desc',
  data () {
    return {
      choiceDisp: false
    }
  },
  props: [ 'dataGroup', 'item', 'choice', 'labelsHrms15e' ],
  methods: {
    toggleChoiceDisp () {
      this.choiceDisp = !this.choiceDisp
    }
  }
}
</script>



// WEBPACK FOOTER //
// itemDesc2.vue?05eee27c